<template>
  <teleport to="#modal_backdrop">
    <div @click="this.$emit('exitModal')" class="backdrop-popup"></div>
    <div class="modal-popup gap-10">
      <div class="type" v-if="!isEdit">
        <label>סוג</label>
        <select v-model="currAlert.type">
          <option disabled value="">בחרו את סוג ההודעה</option>
          <option value="LOG">הודעה</option>
          <option value="POPUP">פופאף</option>
        </select>
      </div>

      <div v-if="currAlert.type === 'LOG'">
        <label>תוכן</label>
        <textarea
          maxlength="50"
          v-model="currAlert.content"
          type="text"
          :placeholder="'תוכן'"
        />
      </div>
      <div v-if="currAlert.type === 'LOG'">
        <label>אייקון</label>
        <Select
          :options="iconsOptions"
          :selectedOptions="selectedIcon"
          @select="selectIcon"
        ></Select>
      </div>
      <div v-else-if="currAlert.type === 'POPUP'">
        <label>תמונה</label>
        <div
          class="image-dropzone"
          :class="{ dragging: isDraggingOverDropzone }"
          @click="triggerFileInput"
          @dragover.prevent="isDraggingOverDropzone = true"
          @dragleave.prevent="isDraggingOverDropzone = false"
          @drop.prevent="onImageDrop"
        >
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            class="hidden-file-input"
            @change="onImageSelected"
          />
          <img
            v-if="imagePreviewUrl"
            :src="imagePreviewUrl"
            class="image-preview"
            alt="תצוגה מקדימה"
          />
          <div v-else class="dropzone-hint">
            <span class="dropzone-icon">🖼️</span>
            <span>גררו תמונה לכאן או לחצו לבחירה</span>
          </div>
        </div>

        <div class="flex gap-10 auto-close-toggle">
          <label for="auto-close-checkbox">סגירה אוטומטית</label>
          <input
            id="auto-close-checkbox"
            type="checkbox"
            v-model="currAlert.autoClose"
          />
        </div>
        <div v-if="currAlert.autoClose" class="flex gap-10 auto-close-toggle">
          <label>מספר שניות לסגירה</label>
          <input
            type="number"
            min="1"
            v-model.number="currAlert.autoCloseSeconds"
          />
        </div>

        <VueMultiselect
          v-model="currAlert.userSelected"
          :options="customers"
          :multiple="true"
          :close-on-select="true"
          placeholder="בחרו משתמשים שיקבלו פופאף זה"
          label="custname"
          track-by="cust"
        />
      </div>

      <BaseButton
        @click="this.saveAlert"
        :isDisabled="isSavingAlert"
        class="submit"
        >{{ isSavingAlert ? "שומר..." : saveOrEdit }}</BaseButton
      >
    </div>
  </teleport>
</template>
<script>
import BaseButton from "../helpers/BaseButton.vue";
import Select from "../helpers/Select.vue";
import VueMultiselect from "vue-multiselect";
import AlertService from "../../services/AlertService";
import { baseUrl } from "../../config";
export default {
  components: {
    BaseButton,
    Select,
    VueMultiselect,
  },
  emits: ["exitModal", "saveAlert"],
  props: {
    saveOrEdit: {
      type: String,
      required: true,
    },
    alert: {
      type: Object,
    },
    customers: {
      type: Array,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      currAlert: {
        type: "",
        content: "בגלל המצב המשלוחים יחולקו עד השעה 17:00",
        editable: true,
        icon: "info",
        imageUrl: null,
        autoClose: false,
        autoCloseSeconds: 5,
        userSelected: null,
      },
      iconsOptions: [
        { title: "מידע", icon: "info" },
        { title: "אזהרה", icon: "alert" },
        { title: "קידומי", icon: "party" },
      ],
      selectedIcon: 0,
      isSavingAlert: false,
      isDraggingOverDropzone: false,
      selectedImageFile: null,
      localImagePreviewUrl: null,
    };
  },
  computed: {
    imagePreviewUrl() {
      if (this.localImagePreviewUrl) return this.localImagePreviewUrl;
      if (!this.currAlert.imageUrl) return null;
      return `${baseUrl}/alert-images/${this.currAlert.imageUrl}`;
    },
  },
  mounted() {
    if (this.alert) {
      this.currAlert = { ...this.alert };
      this.selectedIcon = this.iconsOptions.findIndex(
        (icon) => icon.icon === this.currAlert.icon
      );
    }
  },
  beforeUnmount() {
    if (this.localImagePreviewUrl) {
      URL.revokeObjectURL(this.localImagePreviewUrl);
    }
  },
  methods: {
    async saveAlert() {
      if (!this.currAlert.type) return;
      if (
        this.currAlert.type === "POPUP" &&
        !this.selectedImageFile &&
        !this.currAlert.imageUrl
      )
        return;
      if (
        this.currAlert.type === "POPUP" &&
        !this.currAlert.userSelected?.length
      )
        return;
      if (
        this.currAlert.autoClose &&
        !(this.currAlert.autoCloseSeconds > 0)
      ) {
        this.currAlert.autoCloseSeconds = 5;
      }

      this.isSavingAlert = true;
      try {
        if (this.selectedImageFile) {
          const formData = new FormData();
          formData.append("image", this.selectedImageFile);
          const response = await AlertService.uploadAlertImage(formData);
          this.currAlert.imageUrl = response.data.imageUrl;
        }
        this.$emit("saveAlert", this.currAlert);
      } catch (error) {
        console.log(error);
      } finally {
        this.isSavingAlert = false;
      }
    },
    selectIcon(key) {
      this.selectedIcon = key;
      this.currAlert.icon = this.iconsOptions[key].icon;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onImageSelected(event) {
      const file = event.target.files[0];
      if (file) this.setSelectedImageFile(file);
    },
    onImageDrop(event) {
      this.isDraggingOverDropzone = false;
      const file = event.dataTransfer.files[0];
      if (file) this.setSelectedImageFile(file);
    },
    setSelectedImageFile(file) {
      if (this.localImagePreviewUrl) {
        URL.revokeObjectURL(this.localImagePreviewUrl);
      }
      this.selectedImageFile = file;
      this.localImagePreviewUrl = URL.createObjectURL(file);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped lang="scss">
.backdrop-popup {
  background-color: #000000;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 11;
}

.modal-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 12;
  border-radius: 40px;
  background: #393945;
  padding: 30px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 330px;
}
.type {
  width: 85%;
}
label {
  font-size: $mediumTextSize;
}
textarea {
  height: 100px;
  color: white;
  font-size: $mediumTextSize;
}

select {
  background-color: rgb(57 57 69);
  color: white;
  border-radius: 10px;
}

input[type="number"],
input[type="text"] {
  color: white;
}

.image-dropzone {
  position: relative;
  margin-top: 8px;
  min-height: 100px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgb(120 120 130);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover,
  &.dragging {
    border-color: $primaryTextColor;
    background: rgba(255, 255, 255, 0.06);
  }
}

.hidden-file-input {
  display: none;
}

.dropzone-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: rgb(190 190 195);
  font-size: $mediumTextSize;
  text-align: center;
  pointer-events: none;
}

.dropzone-icon {
  font-size: 28px;
}

.image-preview {
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  border-radius: 10px;
  pointer-events: none;
}

.auto-close-toggle {
  margin: 10px 0;
  justify-content: space-between;
  align-items: center;

  input[type="checkbox"] {
    width: 20px;
    opacity: 1;
    position: static;
    pointer-events: fill;
    border-bottom: none;
    box-shadow: none;
  }
}
</style>